//#region src/ZendeskTag/constants.ts
/**
* SYNCED ENUM: Values in frontend and backend versions of ZendeskTag must be synced!
*
* Any changes here should reflect valid options in the backend enum at:
* monoweb.django_apps.preventive_care.patient_messaging.constants.ZendeskTag
*/
var ZendeskTag = /* @__PURE__ */ function(ZendeskTag) {
	ZendeskTag["CUSTOMER_SHOESTRING"] = "customer-shoestring";
	ZendeskTag["CUSTOMER_COLOR"] = "customer-color";
	ZendeskTag["CUSTOMER_RAINBOW"] = "customer-rainbow";
	ZendeskTag["CUSTOMER_REDBULL"] = "customer-redbull";
	ZendeskTag["CUSTOMER_LDCT_ACS"] = "customer-ldctacs";
	ZendeskTag["CUSTOMER_LDCT_ACS_OLD"] = "customer-ldctACS";
	ZendeskTag["WELCOME_CONVERSATION"] = "welcome-conversation";
	ZendeskTag["WELCOME_MESSAGE"] = "welcome-message";
	ZendeskTag["PROVIDER_INITIATED"] = "provider-initiated";
	ZendeskTag["COMPLETE_HRA_REMINDER"] = "complete-hra-reminder";
	ZendeskTag["COMPLETE_AI_REMINDER"] = "complete-ai-reminder";
	ZendeskTag["SCHEDULING_CARE_COORDINATION"] = "scheduling-care-coordination";
	ZendeskTag["SCHEDULING_CARE_ADVOCATE"] = "scheduling-care-advocate";
	ZendeskTag["SCHEDULING_COLOR_MEDICAL"] = "scheduling-color-medical";
	ZendeskTag["CANCER_BREAST"] = "cancer-breast";
	ZendeskTag["CANCER_CERVICAL"] = "cancer-cervical";
	ZendeskTag["CANCER_COLORECTAL"] = "cancer-colorectal";
	ZendeskTag["CANCER_LUNG"] = "cancer-lung";
	ZendeskTag["CANCER_PROSTATE"] = "cancer-prostate";
	ZendeskTag["CANCER_SKIN"] = "cancer-skin";
	ZendeskTag["CANCER_GENETIC_TESTING"] = "cancer-genetic-testing";
	ZendeskTag["COMPLETED_HRA_NO_AIS"] = "completed-hra-no-ais";
	ZendeskTag["INCOMPLETE_HRA"] = "incomplete-hra";
	ZendeskTag["IPS_ROUTING"] = "ips-routing";
	ZendeskTag["ABNORMAL1YR"] = "abnormal1yr";
	ZendeskTag["VIRTUAL_VISIT_LEVEL_1"] = "virtual-visit-level-1";
	ZendeskTag["VIRTUAL_VISIT_ACTION_ITEMS"] = "virtual-visit-action-items";
	ZendeskTag["VIRTUAL_VISIT_HEART_HEALTH"] = "virtual-visit-heart-health";
	ZendeskTag["VIRTUAL_VISIT_CANCER_BREAST"] = "virtual-visit-cancer-breast";
	ZendeskTag["VIRTUAL_VISIT_CANCER_CERVICAL"] = "virtual-visit-cancer-cervical";
	ZendeskTag["VIRTUAL_VISIT_CANCER_COLORECTAL"] = "virtual-visit-cancer-colorectal";
	ZendeskTag["VIRTUAL_VISIT_CANCER_LUNG"] = "virtual-visit-cancer-lung";
	ZendeskTag["VIRTUAL_VISIT_CANCER_PROSTATE"] = "virtual-visit-cancer-prostate";
	ZendeskTag["VIRTUAL_VISIT_CANCER_PROSTATE_URGENT"] = "virtual-visit-cancer-prostate-urgent";
	ZendeskTag["VIRTUAL_VISIT_CANCER_SKIN"] = "virtual-visit-cancer-skin";
	ZendeskTag["VIRTUAL_VISIT_CANCER_OTHER"] = "virtual-visit-cancer-other";
	ZendeskTag["VIRTUAL_VISIT_SKIN_CONCERNS"] = "virtual-visit-skin-concerns";
	ZendeskTag["VIRTUAL_VISIT_GENETIC_TEST_RESULTS"] = "virtual-visit-genetic-test-results";
	ZendeskTag["VIRTUAL_VISIT_GENETIC_RISK_FACTORS"] = "virtual-visit-genetic-risk-factors";
	ZendeskTag["VIRTUAL_VISIT_QUIT_SMOKING"] = "virtual-visit-quit-smoking";
	ZendeskTag["SCREENING_BREAST_CANCER"] = "screening-breast-cancer";
	ZendeskTag["SCREENING_CERVICAL_CANCER"] = "screening-cervical-cancer";
	ZendeskTag["SCREENING_COLORECTAL_CANCER"] = "screening-colorectal-cancer";
	ZendeskTag["SCREENING_LUNG_CANCER"] = "screening-lung-cancer";
	ZendeskTag["SCREENING_SKIN_CANCER"] = "screening-skin-cancer";
	ZendeskTag["OUTREACH_1_HRA_COMPLETE_REMINDER"] = "outreach-1-hra-complete-reminder";
	ZendeskTag["OUTREACH_2_HRA_COMPLETE_REMINDER"] = "outreach-2-hra-complete-reminder";
	ZendeskTag["OUTREACH_1_KIT_RETURN_REMINDER"] = "outreach-1-kit-return-reminder";
	ZendeskTag["OUTREACH_2_KIT_RETURN_REMINDER"] = "outreach-2-kit-return-reminder";
	ZendeskTag["OUTREACH_1_KIT_ACTIVATION_REMINDER"] = "outreach-1-kit-activation-reminder";
	ZendeskTag["OUTREACH_2_KIT_ACTIVATION_REMINDER"] = "outreach-2-kit-activation-reminder";
	ZendeskTag["OUTREACH_1_AI_COMPLETE_REMINDER"] = "outreach-1-ai-complete-reminder";
	ZendeskTag["OUTREACH_2_AI_COMPLETE_REMINDER"] = "outreach-2-ai-complete-reminder";
	ZendeskTag["OUTREACH_1_VIRTUAL_VISIT_REMINDER"] = "outreach-1-virtual-visit-reminder";
	ZendeskTag["OUTREACH_2_VIRTUAL_VISIT_REMINDER"] = "outreach-2-virtual-visit-reminder";
	ZendeskTag["OUTREACH_3_VIRTUAL_VISIT_REMINDER"] = "outreach-3-virtual-visit-reminder";
	ZendeskTag["OUTREACH_4_VIRTUAL_VISIT_REMINDER"] = "outreach-4-virtual-visit-reminder";
	ZendeskTag["OUTREACH_1_SCREENING_REMINDER"] = "outreach-1-screening-reminder";
	ZendeskTag["OUTREACH_2_SCREENING_REMINDER"] = "outreach-2-screening-reminder";
	ZendeskTag["OUTREACH_3_SCREENING_REMINDER"] = "outreach-3-screening-reminder";
	ZendeskTag["OUTREACH_4_SCREENING_REMINDER"] = "outreach-4-screening-reminder";
	ZendeskTag["PATIENT_INITIATED"] = "patient-initiated";
	ZendeskTag["NEEDS_CAT_FOLLOWUP"] = "needs-cat-followup";
	ZendeskTag["UNABLE_TO_REACH"] = "unable_to_reach";
	ZendeskTag["UNABLE_TO_REACH_CM"] = "unable_to_reach__cm_";
	ZendeskTag["NA"] = "n/a";
	ZendeskTag["SCHEDULING_IN_PROGRESS"] = "scheduling_in_progress";
	ZendeskTag["SELF_SCHEDULED"] = "self_scheduled";
	ZendeskTag["SCHEDULED_PREVIOUSLY"] = "scheduled_previously";
	ZendeskTag["DECLINED_BUT_CAN_CHECK_BACK"] = "declined_but_can_check_back";
	ZendeskTag["DECLINED"] = "declined";
	ZendeskTag["CLOSED_BY_MERGE"] = "closed_by_merge";
	ZendeskTag["NORMAL_AT_HOME_RESULTS"] = "normal_at_home_results";
	ZendeskTag["SCHEDULED"] = "scheduled";
	ZendeskTag["URGENT_SYMPTOM_OUTREACH"] = "urgent_symptom_outreach";
	ZendeskTag["NEW_LUMP_IN_YOUR_BREAST_OR_UNDER_YOUR_ARM"] = "new_lump_in_your_breast_or_under_your_arm";
	ZendeskTag["PAIN_IN_ANY_AREA_OF_THE_BREAST"] = "pain_in_any_area_of_the_breast";
	ZendeskTag["RECTAL_BLEEDING"] = "rectal_bleeding";
	ZendeskTag["BLOOD_IN_THE_STOOL"] = "blood_in_the_stool";
	ZendeskTag["BREAST_SYMPTOMS"] = "breast_symptoms";
	ZendeskTag["COUGHING_UP_BLOOD"] = "coughing_up_blood";
	ZendeskTag["VAGINAL_BLEEDING_AFTER_MENOPAUSE"] = "vaginal_bleeding_after_menopause";
	ZendeskTag["SHORTNESS_OF_BREATH"] = "shortness_of_breath";
	ZendeskTag["HEALTH_HISTORY_QUICK_UPDATE"] = "health_history_quick_update";
	ZendeskTag["RECTAL_BLEEDING_AND_BLOOD_IN_THE_STOOL"] = "rectal_bleeding_and_blood_in_the_stool";
	ZendeskTag["NIPPLE_SYMPTOMS"] = "nipple_symptoms";
	ZendeskTag["URGENT_SYMPTOM_OUTREACH_PRE_2025"] = "urgent_symptom_outreach_pre_2025";
	ZendeskTag["REDACTED_CONTENT"] = "redacted_content";
	ZendeskTag["DERMATOLOGY_APPOINTMENT"] = "dermatology_appointment";
	ZendeskTag["SCREENING_LUNG_CT"] = "screening-lung-ct";
	ZendeskTag["SCREENING_LUNG_CT_UNDERSCORE"] = "screening_lung_ct";
	ZendeskTag["URGENT_SYMPTOM_UNITED_NON_PLAN"] = "urgent_symptom_united_non_plan";
	ZendeskTag["BULK_OUTREACH"] = "bulk_outreach";
	ZendeskTag["AUTO_SOLVED_TICKET"] = "auto_solved_ticket";
	ZendeskTag["IN_AND_POST_TREATMENT_SUPPORT"] = "in_and_post_treatment_support";
	ZendeskTag["UNINSURED"] = "uninsured";
	ZendeskTag["INSURED"] = "insured";
	ZendeskTag["SELECTED_FACILITY"] = "selected-facility";
	ZendeskTag["NO_SELECTED_FACILITY"] = "no-selected-facility";
	ZendeskTag["SYMPTOMS"] = "symptoms";
	ZendeskTag["HIGH_RISK"] = "high-risk";
	ZendeskTag["HIGH_RISK_COHORT"] = "high-risk-cohort";
	ZendeskTag["UNDER_40"] = "under-40";
	ZendeskTag["EAST_COAST_STATE"] = "east-coast-state";
	ZendeskTag["WEST_COAST_STATE"] = "west-coast-state";
	ZendeskTag["CENTRAL_STATE"] = "central-state";
	ZendeskTag["FUSION"] = "fusion";
	ZendeskTag["CRAV2_CONCERN"] = "crav2_concern";
	ZendeskTag["MAVEN_SHARING"] = "maven-sharing";
	ZendeskTag["ABNORMAL"] = "abnormal";
	ZendeskTag["GENETICS"] = "genetics";
	ZendeskTag["CRA_INITIATED_IPS"] = "cra-initiated-ips";
	ZendeskTag["MAMMO_REQUEST"] = "mammo-request";
	ZendeskTag["BREAST_MRI_REQUEST"] = "breast-mri-request";
	ZendeskTag["PAP_REQUEST"] = "pap-request";
	ZendeskTag["COLONOSCOPY_REQUEST"] = "colonoscopy-request";
	ZendeskTag["LDCT_REQUEST"] = "ldct-request";
	return ZendeskTag;
}({});
//#endregion
export { ZendeskTag as t };

//# sourceMappingURL=ZendeskTag-XwbG_E92.js.map